import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

// Aktif kategorileri getir — tüm auth'lu kullanıcılar
export const fetchTemplateCategories = createAsyncThunk(
  'templateCategories/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/template-categories');
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

// Tüm kategorileri getir (aktif + pasif) — yönetim sayfası için
export const fetchAllTemplateCategories = createAsyncThunk(
  'templateCategories/fetchAllAdmin',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/template-categories/all');
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

// Kategori oluştur
export const createTemplateCategory = createAsyncThunk(
  'templateCategories/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post('/template-categories', data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

// Kategori güncelle
export const updateTemplateCategory = createAsyncThunk(
  'templateCategories/update',
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/template-categories/${id}`, data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

// Kategori sil (soft delete)
export const deleteTemplateCategory = createAsyncThunk(
  'templateCategories/delete',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/template-categories/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

const templateCategorySlice = createSlice({
  name: 'templateCategories',
  initialState: {
    // Aktif kategoriler — dropdown'larda kullanılır
    list: [],
    // Tüm kategoriler (aktif + pasif) — yönetim sayfasında kullanılır
    adminList: [],
    loading: false,
    adminLoading: false,
    error: null,
  },
  reducers: {
    clearCategoryError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // fetchTemplateCategories
    builder
      .addCase(fetchTemplateCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTemplateCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchTemplateCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Kategoriler yüklenemedi';
      });

    // fetchAllTemplateCategories (admin)
    builder
      .addCase(fetchAllTemplateCategories.pending, (state) => {
        state.adminLoading = true;
      })
      .addCase(fetchAllTemplateCategories.fulfilled, (state, action) => {
        state.adminLoading = false;
        state.adminList = action.payload || [];
      })
      .addCase(fetchAllTemplateCategories.rejected, (state, action) => {
        state.adminLoading = false;
        state.error = action.payload?.message || 'Kategoriler yüklenemedi';
      });

    // createTemplateCategory → adminList'e ekle
    builder
      .addCase(createTemplateCategory.fulfilled, (state, action) => {
        state.adminList.push(action.payload);
        state.adminList.sort((a, b) => a.order - b.order || a.name.localeCompare(b.name, 'tr'));
        // Aktifse list'e de ekle
        if (action.payload.isActive) {
          state.list.push(action.payload);
          state.list.sort((a, b) => a.order - b.order || a.name.localeCompare(b.name, 'tr'));
        }
      });

    // updateTemplateCategory → her iki listede güncelle
    builder
      .addCase(updateTemplateCategory.fulfilled, (state, action) => {
        const updated = action.payload;
        const adminIdx = state.adminList.findIndex((c) => c._id === updated._id);
        if (adminIdx !== -1) state.adminList[adminIdx] = updated;

        // Aktifse list'te güncelle/ekle, değilse çıkar
        if (updated.isActive) {
          const listIdx = state.list.findIndex((c) => c._id === updated._id);
          if (listIdx !== -1) {
            state.list[listIdx] = updated;
          } else {
            state.list.push(updated);
            state.list.sort((a, b) => a.order - b.order || a.name.localeCompare(b.name, 'tr'));
          }
        } else {
          state.list = state.list.filter((c) => c._id !== updated._id);
        }
      });

    // deleteTemplateCategory (soft delete) → list'ten çıkar
    builder
      .addCase(deleteTemplateCategory.fulfilled, (state, action) => {
        state.list = state.list.filter((c) => c._id !== action.payload);
        const adminIdx = state.adminList.findIndex((c) => c._id === action.payload);
        if (adminIdx !== -1) state.adminList[adminIdx].isActive = false;
      });
  },
});

export const { clearCategoryError } = templateCategorySlice.actions;
export default templateCategorySlice.reducer;
